import * as React from "react";
import { useState, useEffect } from "react";
import "../../assets/icons/edel_icons/style.scss";
import MobStickyBottom from "./MobileStickyBottom";
import DeviceContext from "../../utils/indentifyDevice";
import { Link } from "react-scroll";
import SupportDropdown from "./SupportDropdown";
import ProductMob from "./HeaderMob/ProductMob";
import MarketsMob from "./HeaderMob/MarketsMob";
import ToolsMob from "./HeaderMob/ToolsMob";
import IpoMob from "./HeaderMob/IpoMob";
import ReportsMob from "./HeaderMob/ReportsMob";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import SupportContent from "./HeaderDesk/RevampHeader/SupportContent";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import LoginLogoutsection from "./HeaderMob/LoginLogoutsection";
import TransactMob from "./HeaderMob/TransactMob";
import { useNavigate } from "react-router-dom";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { useSelector } from "react-redux";
import HeaderSection from "./HeaderMob/HeaderSection";
import Drawer from "react-bottom-drawer";
import { LoginLogoutDropdown } from "@frameworks/web/components/features/LoginFlow/ClientUser/LoginLogoutDropdown";
import LoginRegister from "@frameworks/web/components/features/LoginFlow/LoginRegisterPage";
import * as URLConfig from "@frameworks/web/config/domain";
const MobBottomClick = () => {
    const navigate = useNavigate();
    const device = DeviceContext();
    const [isMainPage, setIsMainPage] = useState(null);
    const [activeId, setActiveId] = useState("products-id");
    const [supportPage, setSupportpage] = useState(null);
    const [signUp, setsignUp] = useState(null);
    const [userType, setUserType] = useState();
    const [userID, setUserID] = useState();
    const [openPopUp, setOpenPopup] = React.useState(false);
    const [signupClicked, setSignupClicked] = useState(false);
    const logout = () => {
        localStorage.removeItem("acc_data");
        localStorage.removeItem("jwt_token");
        localStorage.removeItem("user_id");
        localStorage.removeItem("lgnSrc");
        localStorage.removeItem("guest_acc_data");
        navigate("");
        window.location.reload();
    };
    const userId = useSelector((state) => state.accountDetailsReducer.userID);
    const guestUserID = useSelector((state) => state.LoginFlow.guestValidateMPIN.data.guestId);
    const config = URLConfig.config;
    const handleSignUpClick = () => {
        setSignupClicked(true);
        window.location.href = config.accOpeningUrl;
    };
    let checkUserData = async () => {
        if (!!userId) {
            setUserType(ILoginFlows.CLIENT);
            setUserID(userId);
        }
        if (!!guestUserID) {
            setUserType(ILoginFlows.GUEST);
            setUserID(guestUserID);
        }
    };
    useEffect(() => {
        checkUserData();
    }, [userId, guestUserID]);
    useEffect(() => {
        setIsMainPage(false);
        if (DeviceContext().isDesktop) {
        }
        else {
            require("../../stylesheets/components/header/nav/MobileBottomClick.scss");
            require("../../stylesheets/components/header/nav/navMob.scss");
            require("../../stylesheets/components/header/nav/HeaderRefactorMob.scss");
        }
    });
    return (React.createElement("div", { className: "mob-page" },
        React.createElement("header", { className: "mobclick-header" },
            React.createElement("section", { className: "header-container" },
                React.createElement("div", { className: "top-block d-flex" },
                    React.createElement("div", { className: "top-left" }, userID ? (React.createElement("div", { className: "signup-block", onClick: () => {
                            setsignUp(true);
                        } }, userID.substring(0, 3))) : (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "signup-text", onClick: handleSignUpClick }, "Sign Up"),
                        React.createElement("span", { className: "imCircle small-imcircle" }),
                        React.createElement("span", { className: "signup-text ps-1 pe-1", onClick: () => setOpenPopup(true) }, "Sign In"),
                        React.createElement("div", { className: "mb-genericSidebar support-genericSidebar support-content-drp mobiletopnav" },
                            React.createElement(Drawer, { isVisible: openPopUp, onClose: () => setOpenPopup(false), hideScrollbars: true, className: "drawer__handle-wrapper z-index-high backgroundcolor_bluedrawer" }, !!userID
                                ? openPopUp && (React.createElement(LoginLogoutDropdown, { userName: userID, userType: userType }))
                                : openPopUp && (React.createElement(LoginRegister, { setOpenPopup: setOpenPopup }))))))),
                    React.createElement("div", { className: "top-right" },
                        React.createElement("div", { className: "ml-40" },
                            React.createElement("span", { className: " edel-icon-support support-logo" }),
                            React.createElement("span", { className: "support-text", onClick: () => {
                                    setSupportpage(true);
                                } }, "Support"),
                            device && device.isDesktop ? (React.createElement(React.Fragment, null,
                                React.createElement(SupportDropdown, null))) : (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "mb-genericSidebar support-genericSidebar" },
                                    React.createElement(GenericDrawer, { show: supportPage, setShow: setSupportpage, headerComp: React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "DMSan_14_700 txt-midnight-blue px-15 pb-3" }, "Support")), bodyComp: React.createElement(React.Fragment, null,
                                            React.createElement(SupportContent, null),
                                            React.createElement("div", { className: "bottom-content px-3 pb-3" },
                                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100 ", onClick: () => setsignUp(false) }))), parentClass: "z-index-high support-content-drp " }))))))))),
        React.createElement("section", { className: "mobclick-main-block" },
            React.createElement("div", { className: "pb-150 px-3" },
                React.createElement("section", { className: "product-container", id: "products", "data-to-scrollspy-id": "products" },
                    React.createElement(ProductMob, null)),
                React.createElement("section", { className: "markets-container", id: "markets", "data-to-scrollspy-id": "markets" },
                    React.createElement(MarketsMob, null)),
                React.createElement("section", { className: "ipo-container", id: "ipo", "data-to-scrollspy-id": "ipo" },
                    React.createElement(IpoMob, null)),
                React.createElement("section", { className: "tools-container", id: "tool", "data-to-scrollspy-id": "tools" },
                    React.createElement(ToolsMob, null)),
                React.createElement("section", { className: "reports-container", id: "reports", "data-to-scrollspy-id": "reports" },
                    React.createElement(ReportsMob, null)),
                userID ? (React.createElement(React.Fragment, null,
                    React.createElement("section", { className: "reports-container", id: "Transact", "data-to-scrollspy-id": "Transact" },
                        React.createElement(TransactMob, null)),
                    React.createElement("section", { className: "reports-container", id: "Transact", "data-to-scrollspy-id": "Transact" },
                        React.createElement("div", { className: "support-content-drp" },
                            React.createElement(HeaderSection, { title: "Support" }),
                            React.createElement(SupportContent, null))))) : ("")),
            React.createElement("section", { className: "clickable-block-container" },
                React.createElement("section", { className: "clickable-iems" },
                    React.createElement("ul", { className: "clickable-tiles" },
                        React.createElement("li", { className: "sticky-tile" },
                            React.createElement(Link, { to: "products", spy: true, smooth: true, offset: -100, duration: 0 }, "Products")),
                        React.createElement("li", { className: "sticky-tile" },
                            React.createElement(Link, { to: "markets", spy: true, smooth: true, offset: -60, duration: 0 }, "Markets")),
                        React.createElement("li", { className: "sticky-tile" },
                            React.createElement(Link, { to: "ipo", spy: true, smooth: true, offset: -60, duration: 0 }, "IPO")),
                        React.createElement("li", { className: "sticky-tile" },
                            React.createElement(Link, { to: "tool", spy: true, smooth: true, offset: -130, duration: 0 }, "Tools")),
                        React.createElement("li", { className: "sticky-tile" },
                            React.createElement(Link, { to: "reports", spy: true, smooth: true, offset: -130, duration: 0 }, "Reports")),
                        userID ? (React.createElement(React.Fragment, null,
                            React.createElement("li", { className: "sticky-tile" },
                                React.createElement(Link, { to: "Transact", spy: true, smooth: true, offset: -130, duration: 0 }, "Transact")),
                            React.createElement("li", { className: "sticky-tile" },
                                React.createElement(Link, { to: "Support", spy: true, smooth: true, offset: -130, duration: 0 }, "Support")))) : (""))),
                React.createElement("section", { className: "clickable-bg-white" }))),
        React.createElement(MobStickyBottom, { isMainPage: isMainPage }),
        React.createElement("div", { className: "mb-genericSidebar support-genericSidebar" },
            React.createElement(GenericDrawer, { show: signUp, setShow: setsignUp, headerComp: React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "p-3" },
                        React.createElement(LoginLogoutsection, { userName: userID, userType: userType }))), bodyComp: React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "support-content-body" },
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("span", { className: "edel-icon-service icon" },
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" }),
                                    React.createElement("span", { className: "path3" }),
                                    React.createElement("span", { className: "path4" }),
                                    React.createElement("span", { className: "path5" }),
                                    React.createElement("span", { className: "path6" })),
                                React.createElement("span", null, "Service Request")),
                            React.createElement("li", null,
                                React.createElement("span", { className: "edel-icon-logout1 icon" },
                                    React.createElement("span", { className: "path1" }),
                                    React.createElement("span", { className: "path2" })),
                                React.createElement("span", { onClick: logout, className: "txt_bloodRed" }, "Logout")))),
                    React.createElement("div", { className: "bottom-content px-3 mgt-30 pb-3" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100 ", onClick: () => setsignUp(false) }))), parentClass: "z-index-high support-content-drp " }))));
};
export default MobBottomClick;
